import {
  GOOGLE_AD_AUDIENCE_SYNC,
  GOOGLE_CLIENT_CREDENTIAL,
  GOOGLE_CLIENT_CREDENTIALS,
} from '@mm/api-routes';
import AuthenticatedController from './AuthenticatedController';
import { snake } from '../helpers/converterString';
import {
  CreateGoogleClientCredentialsResponse,
  GoogleClientCredential,
} from '../interfaces/googleAds';

export default class GoogleAdsController extends AuthenticatedController {
  static retrieveGoogleClientCredentials(facebookPageId: number) {
    return super.get(GOOGLE_CLIENT_CREDENTIALS(facebookPageId));
  }

  static createGoogleClientCredentials(
    facebookPageId: number,
    payload: Pick<
      GoogleClientCredential,
      'clientId' | 'clientSecret' | 'customerId'
    >,
  ): Promise<CreateGoogleClientCredentialsResponse> {
    return super.post(
      GOOGLE_CLIENT_CREDENTIALS(facebookPageId),
      snake(payload),
    );
  }

  static deleteGoogleClientCredentials(
    facebookPageId: number,
    credentialsId: string,
  ) {
    return super.deleteWithJsonResult(
      GOOGLE_CLIENT_CREDENTIAL(facebookPageId, credentialsId),
      snake({ facebookPageId }),
    );
  }

  static syncAudienceById(
    facebookPageId: number,
    adAudienceId: string | number,
  ) {
    return super.post(
      GOOGLE_AD_AUDIENCE_SYNC(adAudienceId),
      snake({ facebookPageId }),
    );
  }
}
